/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Insurance basis used by normirani rules.
 * @nullable
 */
export type GetSloveniaTaxProfile200YearlyReportingNormiranecInsuranceBasis = typeof GetSloveniaTaxProfile200YearlyReportingNormiranecInsuranceBasis[keyof typeof GetSloveniaTaxProfile200YearlyReportingNormiranecInsuranceBasis] | null;


export const GetSloveniaTaxProfile200YearlyReportingNormiranecInsuranceBasis = {
  full_time_self_employed: 'full_time_self_employed',
  other: 'other',
} as const;
